import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useTableSort} from '../../utils/sortUtilities';
import Spinner from '../Spinner';
import Table from '../Table';

const HEAD_CELLS = [
  {
    id: 'firstName',
    numeric: false,
    disabledPadding: true,
    label: 'First Name',
  },
  {
    id: 'lastName',
    numeric: false,
    disabledPadding: false,
    label: 'Last Name',
  },
  {
    id: 'email',
    numeric: false,
    disabledPadding: false,
    label: 'Email',
  },
  {
    id: 'phoneNumber',
    numeric: false,
    disabledPadding: false,
    label: 'Phone number',
  },
  {
    id: 'address',
    numeric: false,
    disabledPadding: false,
    label: 'Address',
  },
  {
    id: 'birthday',
    numeric: false,
    disabledPadding: false,
    label: 'Birthday',
  },
  {
    id: 'createdAt',
    numeric: false,
    disabledPadding: true,
    label: 'Created at',
  },
];

const DATA_CELLS = [
  'firstName',
  'lastName',
  'email',
  'phoneNumber',
  'address',
  'birthday',
  'createdAt',
];

const SupervisorsTable = ({
  supervisors,
  dataCells = DATA_CELLS,
  headCells = HEAD_CELLS,
  loading,
}) => {
  const navigate = useNavigate();
  const tableOrder = useTableSort('asc', 'createdAt');

  const onRowClick = id => {
    navigate(`/supervisors/${id}`);
  };
  const rowHref = id => `/supervisors/${id}`;

  if (loading) {
    return <Spinner />;
  }

  return (
    <Table
      data={supervisors}
      dataCells={dataCells}
      headCells={headCells}
      onRowClick={onRowClick}
      rowHref={rowHref}
      noToolbar
      {...tableOrder}
    />
  );
};

export default SupervisorsTable;
